module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Ledger Master")]), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('Ledger_Master_List')
      }
    }
  }, [_vm._v("Export")]) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.addEditCard) ? _c('b-card', {
    staticClass: "gutr"
  }, [_c('b-row', {
    staticClass: "align-items-end"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.LedgerMaster.ledgerId ? 'Update ' : 'Add ') + " " + _vm._s(_vm.LedgerMaster.ledger) + " Ledger Details")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Ledger Name\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "ledger",
      "name": "ledger",
      "disabled": (_vm.$sessionsStorage.get('designation') == 'Admin' && _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? false : _vm.LedgerMaster.ledgerId ? true : false,
      "placeholder": "Ledger Name"
    },
    model: {
      value: (_vm.LedgerMaster.ledger),
      callback: function($$v) {
        _vm.$set(_vm.LedgerMaster, "ledger", $$v)
      },
      expression: "LedgerMaster.ledger"
    }
  }), _vm._v(" "), (!_vm.LedgerMaster.ledger) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.ledger) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Income Direct\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "incomeDirect",
      "name": "incomeDirect",
      "disabled": (_vm.$sessionsStorage.get('designation') == 'Admin' && _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? false : _vm.LedgerMaster.ledgerId ? true : false,
      "placeholder": "Income Direct"
    },
    model: {
      value: (_vm.LedgerMaster.incomeDirect),
      callback: function($$v) {
        _vm.$set(_vm.LedgerMaster, "incomeDirect", $$v)
      },
      expression: "LedgerMaster.incomeDirect"
    }
  }), _vm._v(" "), (!_vm.LedgerMaster.incomeDirect) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.incomeDirect) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Shipment Type\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.shipmentTypeList,
      "selected-options": _vm.shipmentType_items,
      "placeholder": "Select Shipment Type",
      "multiple": true
    },
    on: {
      "select": _vm.SelectMultishipmentType
    },
    model: {
      value: (_vm.LedgerMaster.shipmentType),
      callback: function($$v) {
        _vm.$set(_vm.LedgerMaster, "shipmentType", $$v)
      },
      expression: "LedgerMaster.shipmentType"
    }
  }), _vm._v(" "), (!_vm.LedgerMaster.shipmentType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.shipmentType) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Module Type\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.moduelTypeList,
      "selected-options": _vm.moduelType_items,
      "placeholder": "Select Module Type",
      "multiple": true
    },
    on: {
      "select": _vm.SelectMultimoduelType
    },
    model: {
      value: (_vm.LedgerMaster.moduelType),
      callback: function($$v) {
        _vm.$set(_vm.LedgerMaster, "moduelType", $$v)
      },
      expression: "LedgerMaster.moduelType"
    }
  }), _vm._v(" "), (!_vm.LedgerMaster.moduelType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.moduelType) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Job Type\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.jobTypeList,
      "selected-options": _vm.jobType_items,
      "placeholder": "Select Job Type",
      "multiple": true
    },
    on: {
      "select": _vm.SelectMultijobType
    },
    model: {
      value: (_vm.LedgerMaster.jobType),
      callback: function($$v) {
        _vm.$set(_vm.LedgerMaster, "jobType", $$v)
      },
      expression: "LedgerMaster.jobType"
    }
  }), _vm._v(" "), (!_vm.LedgerMaster.jobType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.jobType) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Status :\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "id": 'approval' + _vm.LedgerMaster.isLedgerActive,
      "name": "approval",
      "value": _vm.LedgerMaster.isLedgerActive == true ? true : false
    },
    on: {
      "change": function($event) {
        _vm.activateLedgerMaster()
      }
    }
  }, [_c('h6', [_c('b-badge', {
    attrs: {
      "variant": _vm.LedgerMaster.isLedgerActive == 1 ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.LedgerMaster.isLedgerActive == 1 ? "Active" : "In-Active"))])], 1)])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [(_vm.TAXPercentageArr.length > 0) ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Percentage")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                        Actions\n                        "), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addMultiTaxPercentage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.TAXPercentageArr), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Tax Percentage"
      },
      on: {
        "input": function($event) {
          _vm.getTaxPercentage(item)
        }
      },
      model: {
        value: (item.tax_percentage),
        callback: function($$v) {
          _vm.$set(item, "tax_percentage", $$v)
        },
        expression: "item.tax_percentage"
      }
    }), _vm._v(" "), (item.tax_percentage_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.tax_percentage_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(index > 0) ? _c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeMultiTaxPercentage(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1)])
  })], 2)])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-bottom": "0.3rem"
    },
    attrs: {
      "variant": "success",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addLedgerMaster
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.LedgerMaster.ledgerId ? "Update" : "Save") + "\n                  ")])], 1), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Ledger Master and Code"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addEditCardFunc()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  }), _vm._v(" "), (_vm.isFileLoading) ? _c('span', [_vm._v("Uploading....."), _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.MasterLedgerList,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "responsive": "",
      "primary-key": "ledgerId"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "ledgerId",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                    " + _vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n                  ")])]
      }
    }, {
      key: "ledger",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.ledger))])]
      }
    }, {
      key: "incomeDirect",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.incomeDirect))]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "shipmentType",
      fn: function(row2) {
        return [_c('span', [_vm._v("Shipment Type : " + _vm._s(row2.item.shipmentType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Module Type : " + _vm._s(row2.item.moduelType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Job Type : " + _vm._s(row2.item.jobType))])]
      }
    }, {
      key: "isLedgerActive",
      fn: function(row3) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row3.item.ledgerId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row3.item.ledgerId,
            "name": "approval",
            "value": row3.item.isLedgerActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUser(row3.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row3.item.isLedgerActive == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row3.item.ledgerId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row3.item.isLedgerActive == 1 ? "Active" : "In-Active"))])], 1)])]
      }
    }, {
      key: "is_air",
      fn: function(row3) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row3.item.ledgerId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row3.item.ledgerId,
            "name": "approval",
            "value": row3.item.is_air == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.changeToAir(row3.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row3.item.is_air == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row3.item.ledgerId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row3.item.is_air == 1 ? "Air" : "Normal"))])], 1)])]
      }
    }, {
      key: "creationTime",
      fn: function(row3) {
        return [_vm._v(_vm._s(row3.item.creationTime))]
      }
    }, {
      key: "action",
      fn: function(row2) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editLedgerLocation(row2.item)
            }
          }
        }, [_vm._v("Update")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b53ea7a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/masters/ledgerMaster.vue
// module id = 2536
// module chunks = 0